import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useWidth } from "../../../../hooks/use-width";
import { paths } from "../../../../routes/paths";
import NavbarItem from "../navbar-item/navbar-item";
import "./burger-menu.sass";

type Props = {
  theme?: "white" | "blue";
};

const BurgerMenu = ({ theme = "white" }: Props) => {
  const { isMobileWidth } = useWidth();
  const [isOpen, setOpen] = useState<boolean>(false);
  const { pathname } = useLocation();

  const toggleMenu = () => {
    setOpen((state) => !state);
  };

  useEffect(() => {
    if (!isMobileWidth && isOpen) {
      setOpen(false);
    }
  }, [isMobileWidth, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return isMobileWidth ? (
    <>
      <button
        type="button"
        aria-label="Открыть меню"
        className={`burger-menu__button ${isOpen ? "menu-open" : ""}`}
        onClick={toggleMenu}
      >
        <div
          className={`burger-menu__line ${
            isOpen ? "burger-menu__line__open" : ""
          }`}
        ></div>
        <div
          className={`burger-menu__line ${
            isOpen ? "burger-menu__line__open" : ""
          }`}
        ></div>
        <div
          className={`burger-menu__line ${
            isOpen ? "burger-menu__line__open" : ""
          }`}
        ></div>
      </button>

      <div className={`burger-menu ${isOpen ? "open" : ""}`}>
        <div className="burger-menu__overlay" onClick={toggleMenu}></div>

        <div className="burger-menu__content">
          <div className="burger-menu__list">
            <NavbarItem title="о Нас" link={paths.AboutUsPage} theme={theme} />

            <NavbarItem title="услуги" link={paths.ServicesPage} theme={theme} />

            <NavbarItem title="Кейсы" link={paths.CasesPage} theme={theme} />

            <NavbarItem title="тендерхаб" link={paths.TenderhubPage} theme={theme} />

            <NavbarItem
              title="Шоурилл"
              isBacklink={true}
              link={paths.ShowreelPage}
              theme={theme}
            />

            <NavbarItem title="контакты" link={paths.ContactsPage} theme={theme} />
          </div>
        </div>
      </div>
    </>
  ) : (
    <div className=""></div>
  );
};

export default BurgerMenu;
